class Utils {
    static formatDataAddRemoveDays(value, days, operation) {
        const date = value ? new Date(value) : new Date()
        const dayToCount = days ?? 30
        operation === "+" ? date.setDate(date.getDate() + dayToCount) : date.setDate(date.getDate() - dayToCount);

        const dia = date.getDate().toString().padStart(2, '0');
        const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() retorna 0-11
        const ano = date.getFullYear();

        const dateString = `${ano}-${mes}-${dia}`;

        return dateString;
    }

    static formatData(value) {
        console.log(value);
        // format date to dd/mm/yyyy
        let date = value && value.length === 10 ? new Date(value + " 00:00:00") : new Date(value);

        const dia = (date.getDate()).toString().padStart(2, '0');
        const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() retorna 0-11
        const ano = date.getFullYear();

        let dateString = dia + '/' + mes + '/' + ano;
        return dateString;
    };

    static formatCnpj(cnpj) {
        // Format CNPJ as needed
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    static formatCpf(cpf) {
        if (cpf && cpf.length === 11) {// Remove all non-digit characters from the input
            cpf = cpf.replace(/\D/g, '');

            // Limit the string to at most 11 digits; remove excessive leading zeros
            // Ensure the length is cut to 11 if there are more than 11 digits.
            if (cpf.length > 11) {
                cpf = cpf.substring(cpf.length - 11);
            }

            // Format the CPF number as XXX.XXX.XXX-XX
            // This will only format if there are exactly 11 digits present.
            return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        }
    }

    static validateCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(cpf.charAt(10));
    }

    static validaCNPJ(cnpj) {
        // Check if CNPJ-specific digits match a CNPJ pattern
        // return number.substr(11, 3) === '000';
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        var c = String(cnpj).replace(/[^\d]/g, '')

        if (c.length !== 14)
            return false

        if (/0{14}/.test(c))
            return false

        for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
        if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
        if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        return true
    }

    static formatTelefone(telefone) {
        // Format CNPJ as needed
        if (telefone.length === 10)
            return telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1)$2-$3');
        if (telefone.length === 11)
            return telefone.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, '($1)$2.$3-$4');
    }

    static formatMoney(inputValue) {
        // Remove leading zeros
        const cleanedValue = inputValue.replace(/^0+/, '');

        // Parse value as number
        const numericValue = parseInt(cleanedValue);

        // Format as BRL currency
        const formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numericValue / 100);

        return formattedValue;
    }

    static formatCurrency = (value) => {

        if (value == null) {
            value = 0;
        }
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    /**
   * Converte milissegundos para formato de duração (ex: "1h 30m 45s" ou "2m 15s")
   * @param {number} ms - Milissegundos
   * @returns {string} Duração formatada
   */
    static formatDuration(ms) {
        const seconds = Math.floor(ms / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const remainingSeconds = seconds % 60;

        if (hours > 0) {
            return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
        } else if (minutes > 0) {
            return `${minutes}m ${remainingSeconds}s`;
        } else {
            return `${remainingSeconds}s`;
        }
    }

    /**
     * Formata string ISO 8601 para "dd/mm/yyyy HH:mm" em português brasileiro
     * @param {string} isoString - String ISO 8601
     * @returns {string} Data e hora formatada
     */
    static formatDateTime(isoString) {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    }

    /**
     * Formata string ISO 8601 para "HH:mm" em português brasileiro
     * @param {string} isoString - String ISO 8601
     * @returns {string} Hora formatada
     */
    static formatTime(isoString) {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    }

    /**
     * Formata uma string ISO 8601 para "dd/mm/yyyy HH:mm" no fuso horário local.
     * @param {string|Date|null} isoString - A string de data ISO 8601 ou objeto Date.
     * @returns {string} A data e hora formatada ou string vazia se inválida.
     */
    static formatTimestamp(isoString) {
        if (!isoString) return '';
        const date = new Date(isoString);
        if (isNaN(date.getTime())) {
            console.error("Utils.formatTimestamp: Data inválida fornecida", isoString);
            return '';
        }
        return new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    /**
     * Retorna cor para badge baseada no status
     * @param {string} status - Status (completed, running, error, failed, pending)
     * @returns {string} Cor do badge
     */
    static getStatusColor(status) {
        const colors = {
            completed: 'success',
            running: 'info',
            error: 'danger',
            failed: 'danger',
            pending: 'warning',
        };
        return colors[status] || 'secondary';
    }

    /**
     * Retorna label amigável em português para o status
     * @param {string} status - Status
     * @returns {string} Label amigável
     */
    static getStatusLabel(status) {
        const labels = {
            completed: 'Concluído',
            running: 'Em andamento',
            error: 'Erro',
            failed: 'Falha',
            pending: 'Pendente',
        };
        return labels[status] || status;
    }

    /**
     * Retorna label amigável para o tipo de gatilho
     * @param {string} triggeredBy - Tipo de gatilho
     * @returns {string} Label amigável
     */
    static getTriggerLabel(triggeredBy) {
        const labels = {
            manual: 'Manual',
            'keep-alive-service': 'Automático',
            scheduled: 'Programado',
        };
        return labels[triggeredBy] || triggeredBy;
    }

    /**
     * Calcula porcentagem com 1 casa decimal
     * @param {number} value - Valor
     * @param {number} total - Total
     * @returns {string} Porcentagem formatada
     */
    static calculatePercentage(value, total) {
        if (total === 0) return '0.0';
        const percentage = (value / total) * 100;
        return percentage.toFixed(1);
    }

    /**
     * Formata bytes para KB, MB, GB
     * @param {number} bytes - Bytes
     * @returns {string} Bytes formatados
     */
    static formatBytes(bytes) {
        if (bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    /**
     * Formata milissegundos para "Xms", "Xs" ou "Xm Ys"
     * @param {number} ms - Milissegundos
     * @returns {string} Milissegundos formatados
     */
    static formatMilliseconds(ms) {
        if (ms < 1000) {
            return `${ms}ms`;
        } else if (ms < 60000) {
            const seconds = (ms / 1000).toFixed(1);
            return `${seconds}s`;
        } else {
            const minutes = Math.floor(ms / 60000);
            const seconds = Math.floor((ms % 60000) / 1000);
            return `${minutes}m ${seconds}s`;
        }
    }

    /**
     * Verifica se a data é recente (dentro de X dias)
     * @param {Date|string} date - Data
     * @param {number} days - Número de dias (padrão 7)
     * @returns {boolean} Se é recente
     */
    static isRecent(date, days = 7) {
        const now = new Date();
        const targetDate = new Date(date);
        const diffTime = now - targetDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays <= days;
    }

    /**
     * Calcula diferença entre duas datas em dias
     * @param {Date|string} date1 - Primeira data
     * @param {Date|string} date2 - Segunda data
     * @returns {number} Diferença em dias
     */
    static getDaysDifference(date1, date2) {
        const d1 = new Date(date1);
        const d2 = new Date(date2);
        const diffTime = Math.abs(d2 - d1);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    /**
     * Calcula diferença entre duas datas em horas
     * @param {Date|string} date1 - Primeira data
     * @param {Date|string} date2 - Segunda data
     * @returns {number} Diferença em horas
     */
    static getHoursDifference(date1, date2) {
        const d1 = new Date(date1);
        const d2 = new Date(date2);
        const diffTime = Math.abs(d2 - d1);
        return Math.ceil(diffTime / (1000 * 60 * 60));
    }

    /**
     * Trunca texto com "..."
     * @param {string} text - Texto
     * @param {number} length - Comprimento máximo (padrão 50)
     * @returns {string} Texto truncado
     */
    static truncateText(text, length = 50) {
        if (text.length <= length) return text;
        return text.substring(0, length) + '...';
    }

    /**
     * Retorna ícone PrimeReact para o status
     * @param {string} status - Status
     * @returns {string} Classe do ícone
     */
    static getStatusIcon(status) {
        const icons = {
            completed: 'pi pi-check',
            running: 'pi pi-spin pi-spinner',
            error: 'pi pi-times',
            failed: 'pi pi-exclamation-triangle',
            pending: 'pi pi-clock',
        };
        return icons[status] || 'pi pi-question';
    }

    /**
     * Retorna label amigável para tipo de sincronização
     * @param {string} type - Tipo
     * @returns {string} Label amigável
     */
    static getSyncTypeLabel(type) {
        const labels = {
            produtos: 'Produtos',
            categorias: 'Categorias',
        };
        return labels[type] || type;
    }
}

export default Utils;
